import React, { forwardRef } from 'react';

const IcStatusDormant = forwardRef((properties, ref) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    fill: "none",
    height: "16",
    viewBox: "0 0 16 16",
    width: "16",
    xmlns: "http://www.w3.org/2000/svg",
    ...properties,
    ref
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M2.5 8.5H6L2.5 12H6",
      stroke: "var(--color-status-device-dormant)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9 4.5H13.5L9 9H13.5",
      stroke: "var(--color-status-device-dormant)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2"
    }
  )
));

export { IcStatusDormant };
//# sourceMappingURL=ic-status-dormant.js.map
